import React, { useEffect, useState, Fragment } from 'react';
import $ from 'jquery';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import MaterialTable from "material-table";
import { IconButton } from '@material-ui/core';
import StopCircleIcon from '@mui/icons-material/StopCircle';

export const EOSListing = ({ eosData, handleClick }) => {

    const [eos, setEos] = useState([]);

    useEffect(() => {
        trackPromise(
            setEOSData()
        )
    }, [eosData]);

    async function setEOSData() {
        if (eosData) {
            for (const item of eosData) {
                var startDateTime = item.sosStartDateTime.split("T");
                var startTime = startDateTime[1].split(".")

                item.startTime = startDateTime[0] + " " + startTime[0];
            }
        }
        destroyDataTable();
        await setEos(eosData);
        createDataTable();
    }

    function destroyDataTable() {
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <MaterialTable
                title="Multiple Actions Preview"
                columns={[
                    { title: 'Package Name', field: 'packageName', headerStyle: { fontWeight: "bold" } },
                    { title: 'Start Time', field: 'startTime', headerStyle: { fontWeight: "bold" } },
                    {
                        title: 'Status', field: 'isSOSEnabled',
                        render: rowData => rowData.isSOSEnabled == true ? "Active" : "Inactive", headerStyle: { fontWeight: "bold" }
                    },
                    {
                        title: 'Action', field: 'select', headerStyle: { fontWeight: "bold" },
                        render: (data) => (
                            <IconButton aria-label="stopCircle" onClick={() => handleClick(data)}>
                                <StopCircleIcon />
                            </IconButton>
                        ),
                    }
                ]}
                data={eos}
                options={{
                    exportButton: false,
                    showTitle: false,
                    headerStyle: { textAlign: "left", height: '1%' },
                    cellStyle: { textAlign: "left" },
                    columnResizable: false,
                    actionsColumnIndex: -1
                }}
            />
        </Fragment>
    );
}


